export type uploadState = "uploaded" | "uploadInProgress" | "noFiles";

export const FileTypeCode = {
  C1P: "C1P", //contract
  CCP: "CCP",
  C3P: "C3P",
  CAP: "CAP",
  CDP: "CDP",
  C7P: "C7P",
  E3P: "E3P",
  EAP: "EAP",
  C0P: "C0P",
  LSP: "LSP",
  LRP: "LRP",
  LTP: "LTP",
  CXP: "CXP",
  ECP: "ECP",
  C8P: "C8P",
  CNP: "CNP",
  C5P: "C5P",
  C4P: "C4P",
  CGP: "CGP",
  CQP: "CQP",
  CLP: "CLP",
  C2P: "C2P",
  EFP: "EFP",
  CVP: "CVP",
  D2P: "D2P",
  L3P: "L3P",
  COP: "COP",
  System: "SYSTEM",
  PowerOfAttorneyTemplate: "POWER_OF_ATTORNEY_TEMPLATE",
  CoverSheet: "COVER_SHEET",
  SignedContract: "SIGNED_CONTRACT",
  CoverLetter: "COVER_LETTER",
  WelcomeLetter: "WELCOME_LETTER",
};

export const unsuportedJpegFileExtensions = [".jfif", ".pjpeg", ".pjp"];
export enum ErrorCodeLocal {
  alreadyLoading = "already-loading",
  unsuportedJpegExtension = "unsuported-jpeg-extension",
}

export interface AttachmentOptions {
  fileType?: string;
  humanName?: string;
  groupId?: number | string;
  internal?: boolean;
  biometric?: boolean;
  paperRequest?: boolean;
}
